<template>
    <div class="container">
        <QueryFrame
                @handlePage='handlePage'
                @handlePageSize='handlePageSize'
                @open='open'
                @cancel='cancel'
                @print='print'
                @deleteItem='deleteItem'
                :disablePage='disablePage'
                :current='page'
                :count='count'>
            <div slot="queryParams" class="form">

            <div class="queryContainer">
              <div class="queryItem">
                <label>供应商名称:</label>
                <SupplierListSelect isGeneral v-model="query.supplierBaseIdList" multiple></SupplierListSelect>
              </div>
              <div class="queryItem">
                <label>社会统一码:</label>
                <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.creditCode'></lk-input>
              </div>
              <div class="queryItem">
                <label>助记码:</label>
                <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.mnemonicCode' />
              </div>
              <div class="queryItem">
                <label>编码:</label>
                <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model.trim='query.code' />

              </div>
              <div class="queryItem">
                <label>创建时间:</label>
    <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' />

              </div>
              <div class="queryItem">
                <label>状态:</label>
                <lk-select class="item" clearable v-model.trim='query.status'>
                  <lk-option v-for="(item,index) in status" :key="item" :value='index+1'>
                    {{item}}
                  </lk-option>
                </lk-select>
              </div>

              <div class="queryItem">
                <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
                <lk-button @click="clear">重置</lk-button>
              </div>
            </div>
            </div>
            <div slot="table">
              <lk-button
                class="mr8"
                type="primary"
                icon="md-add"
                @click="addNew"
                v-if="handlePermission('supplierGeneralAdd')">新建基础供应商
              </lk-button>
              <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('supplierGeneralDownload')"></DownloadButton>
              <lk-table border :columns='columns' :data='tableData'></lk-table>
            </div>
        </QueryFrame>

        <!-- <lk-modal v-model="statusModal" title="禁用原因" :mask-closable='false' :closable='false'>
          <div>
            <lk-input type='textarea' :row='4' placeholder="请输入禁用原因" v-model="disableReason">

            </lk-input>
          </div>

            <div slot="footer">
              <lk-button @click="statusModal = false; getData(); disableReason=''">取消</lk-button>
              <lk-button type='primary' :loading='disableLoading' @click="handleDisable">确定</lk-button>
            </div>
        </lk-modal> -->
        <lk-modal :title="isStop ? '停用供应商' : '启用供应商'" v-model="statusModal" :footer-hide='true' width="400" :closable='false'
        :mask-closable='false'>
      <div style="display:flex;">
          <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
          <h6 style="margin-top: 7px;font-size: 12px;">是否确认{{ isStop ? '停用' : '启用'}}此供应商？</h6>
      </div>
      <div style="display:flex">
        <span v-if="isStop" class="redMark">*</span>
        <span :class="isStop ? 'stopReason' : 'reason'">{{ isStop ? '停用原因：' : '停用原因：' + disableReason}}</span>
      </div>
      <lk-input v-if="isStop" class="stopInput"  placeholder='请输入停用原因' :maxlength="100" clearable v-model.trim="disableReason" type="textarea"></lk-input>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="isStop ? disableReason == '' : false" @click="editGoods(disableId)">确认</lk-button>
          <lk-button @click="statusModal=false, getData()">取消</lk-button>
      </div>
    </lk-modal>
    </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../../services/supplier';
import supplier from '../../../services/supplier';
// // import timeStampDatePicker from '../../../components/timeStampDatePicker.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import DownloadButton from '../../../components/download/DownloadButton';
import SupplierListSelect from '../../../components/SupplierListSelect.vue';

export default {
  name: 'SupplierGeneral',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    SupplierListSelect,
  },
  data() {
    return {
      isStop: true,
      statusModal: false,
      disableLoading: false,
      disableReason: '',
      disableId: null,
      enterpriseTypeList: ['', '药品经营', '药品生产', '食品（生产、经营）', '器械生产', '器械经营', '化妆品'],

      disablePage: false,
      params: {
        duration: [],
        name: '',
        mnemonicCode: '',
        // socialCode: '',
        code: '',

        status: '',
        statusCodeList: [],
      },
      query: {
        duration: [],
        supplierBaseIdList: [],
        mnemonicCode: '',
        // socialCode: '',
        code: '',

        status: '',
        statusCodeList: [],
      },
      columns: [
        { title: '编码', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'name', minWidth: 116 },
        { title: '社会统一码', key: 'socialUnifyCreditCode', minWidth: 116 },
        { title: '助记码', key: 'memoryCode', minWidth: 116 },
        // { title: '社会统一代码', key: 'socialUnifyCreditCode', minWidth: 116 },
        { title: '企业法人', key: 'corporationPerson', minWidth: 116 },
        { title: '注册地址', key: 'detailAddress', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '企业性质', key: 'enterpriseType', minWidth: 116 },
        {
          title: '状态',
          minWidth: 116,
          fixed: 'right',
          key: 'baseInfoStatus',
          render: (h, params) => (this.handlePermission('supplierGeneralEnableDisable') ? h('lk-switch', {
          // render: (h, params) => h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.status === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (e) => { // 接口有问题后续调
                params.row.loading = true;
                if (e) {
                  this.isStop = false;
                  this.disableReason = params.row.disableReason;
                } else {
                  this.isStop = true;
                  this.disableReason = '';
                }
                this.statusModal = true;
                this.disableId = params.row.id;
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',

            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',

            }, '禁用'),
          ]) : h('span', params.row.status === 1 ? '启用' : '禁用')),


        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.handlePermission('supplierGeneralCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'supplierGeneralCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('supplierGeneralEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'supplierGeneralEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
            this.handlePermission('supplierGeneralFirstList') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'supplierGeneralFirstList',
                    params: {
                      id: params.row.id,
                      code: params.row.code,
                      name: params.row.name,
                      socialCode: params.row.socialUnifyCreditCode,
                    },
                  });
                },
              },
            }, '门店首营') : null,
          ]),
        },
      ],
      tableData: [],
      localtion: [],
      status: ['启用', '禁用'],
    };
  },
  methods: {
    editGoods(id) {
      this.statusModal = false;
      if (!this.isStop) {
        supplier.supplierGeneralEnable({ id }).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('该供应商已启用');
          } else {
            this.$Message.error(res.data.error);
          }
          this.disableReason = '';
          this.getData();
        }).catch((err) => {
          this.getData();
          utils.handleError(err);
        });
      } else {
        supplier.supplierGeneralDisable({ id, disableReason: this.disableReason }).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('该供应商已禁用');
          } else {
            this.$Message.error(res.data.error);
          }
          this.getData();
          this.disableReason = '';
        }).catch((err) => {
          this.getData();
          utils.handleError(err);
        });
      }
    },
    download() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.queryCondition = utils.getQueryCondition('.queryContainer');
      if (this.params.duration[1]) {
        this.params.createTimeStartMs = this.params.duration[0];
        this.params.createTimeEndMs = this.params.duration[1];
        // this.params.createTimeEnd = this.params.createTimeStart;
      } else {
        this.params.createTimeStartMs = '';
        this.params.createTimeEndMs = '';
      }
      this.params.statusCodeList = this.params.status ? [this.params.status] : [];
      supplier.downloadGeneral(this.params).then((res) => {
        // utils.downLoadExcel(res, '销售明细查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleDisable() {
      if (!this.disableReason) {
        this.$Message.error('请填写禁用原因');
        return;
      }
      this.disableLoading = true;
      supplier.supplierGeneralDisable({ id: this.disableId, disableReason: this.disableReason }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('该供应商已禁用');

          this.statusModal = false;
        } else {
          this.$Message.error(res.data.error);
        }
        this.getData();
        this.disableLoading = false;
        this.disableReason = '';
        // console.log(params.row.baseInfoStatus);
      }).catch((err) => {
        this.disableLoading = false;
        this.getData();
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        duration: [],
        name: '',
        mnemonicCode: '',
        // socialCode: '',
        code: '',
        creditCode: '',
        status: '',
        statusCodeList: [],
      };
    },
    getlocaltions() {

    },
    loadLocaltion() {

    },
    // handleSearch() {
    //   this.params = Object.assign(this.params, this.query);
    //   this.handlePage(1, true);
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration[1]) {
        this.params.createTimeStartMs = this.params.duration[0];
        this.params.createTimeEndMs = this.params.duration[1];
        // this.params.createTimeEnd = this.params.createTimeStart;
      } else {
        this.params.createTimeStartMs = '';
        this.params.createTimeEndMs = '';
      }
      this.params.statusCodeList = this.params.status ? [this.params.status] : [];
      console.log(supplier);
      supplier.SupplierGeneralList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          // console.log(res.data);
          this.count = res.data.data.count;
          // this.count = res.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTimeStart = utils.exchangeTime(result.createTimeStart);
            // result.status = this.status[result.status - 1];
            // console.log(result);
            result.createTime = utils.exchangeTime(result.createTime);
            result.loading = false;
            const types = result.enterpriseType.split(',');
            result.enterpriseType = [];
            types.forEach((val) => {
              result.enterpriseType.push(this.enterpriseTypeList[val * 1]);
            });

            result.enterpriseType = result.enterpriseType.join(',');
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   if (isSearch) {
    //     this.disablePage = true;
    //     // console.log(1234123);

    //     this.$nextTick(() => {
    //       this.disablePage = false;
    //       this.size = 10;
    //       this.getData();
    //     });
    //   } else {
    //     this.getData();
    //   }
    // },
    // handlePageSize(size) {
    //   this.size = size; this.page = 1;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'supplierGeneralAdd' });
    },
    open() {
      // console.log(2);
    },
    cancel() {
      // console.log(3);
    },
    print() {
      // console.log(4);
    },
    deleteItem() {
      // console.log(5);
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>

<style lang="less" scoped>
    // .form {
        // margin-top: 16px;
        // padding-bottom: 24px
    // }
.bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}

.warnIcon {
  color: orange;
  font-size: 20px;
};

.stopReason {
  margin-top:8px; font-size: 12px;
}

.reason {
  margin-top:8px;
  font-size: 12px;
  margin-left: 24px;
}

.redMark {
  color: red;
  margin-top:6px;
  margin-left: 24px;
  font-size: 18px;
}

.stopInput{
  margin-left:24px;
  margin-right: 20px;
  width: 340px;
  margin-top: 0px;
}
</style>
